import React, { useState } from 'react';
import './RiderAssignments.scss';
import { CopyText } from '../../../UiKit';
import { EmptyState, WFHCall } from '../../commons';
import { InvalidSearchImg, viewText } from '../../../images/images';
import { valetModel } from '../../../api';
import {
  VALET_EVENTS,
  sendValetApiEvents,
} from '../../../helpers/analytics/valet.analytics';
import toast from 'react-hot-toast';
import { AssignedRiderCallClickEvent } from '../../../analytics/call-logging/events';
import { useSelector } from 'react-redux';

export const riderRoles = {
  BUDDY_RIDER: 'BUDDY_RIDER',
  RIDER: 'RIDER',
};

const ambulanceRoles = [
  'Paramedic',
  'Ambulance Pilot',
  'General Duty Assistant',
];

function unmaskNumber(orderID, setNumber, setisMask, id) {
  const queryParams = {
    order_id: orderID,
    offset: id,
  };

  valetModel
    .getDPAssignedUnassignedNumbers(queryParams)
    .then((response) => {
      if (!response || response?.isError === true) {
        return toast.error(
          response.message || 'Something went wrong. Please try again later!',
        );
      }

      sendValetApiEvents(VALET_EVENTS.GET_VALET_NUMBER_SUCCESS, orderID);
      setisMask(false);
      setNumber(response.phone);
    })
    .catch((err) => {
      toast.error(
        err.message || 'Something went wrong. Please try again later!',
      );

      sendValetApiEvents(VALET_EVENTS.GET_VALET_DETAILS_FAILURE, orderID);
    });
}
const ValetDeliveryAssignmentHistory = (props) => {
  const { offset, phone, calledTo, orderId, userId } = props;
  const [number, setNumber] = useState(phone);
  const [isMask, setisMask] = useState(true);
  return (
    <div>
      {isMask ? (
        <div className='tw-flex tw-flex-row'>
          <CopyText
            dontShowCopyIcon={true}
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
          />
          <span
            className='pointer icon'
            onClick={() => unmaskNumber(orderId, setNumber, setisMask, offset)}
          >
            <img src={viewText} alt='' />
          </span>
        </div>
      ) : (
        <div>
          <CopyText
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
          />
        </div>
      )}
    </div>
  );
};

export const RiderAssignmentsV1 = ({ data, orderId, userId, cartId }) => {
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  if (data?.isError) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={data?.message || 'No data available.'}
        isPop={true}
      />
    );
  }
  const assignment_history = data?.assignment_history;
  if (!assignment_history || assignment_history.length == 0) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading='No data available.'
        isPop={true}
      />
    );
  }

  return (
    <div className='tw-flex tw-items-center tw-w-fit tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-1 tw-border-solid tw-border-grey-300/70 tw-mx-10 tw-overflow-hidden'>
      <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-2xl'>
              <th
                title='Complaint Item'
                className='tw-w-[25%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Delivery Partner
              </th>
              <th
                title='Complaint Qty'
                className='tw-w-[16%] tw-whitespace-nowrap tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Phone Number
              </th>
              <th
                title='Total Price'
                className=' tw-px-1 tw-whitespace-nowrap tw-w-[18%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Assigned At
              </th>
              <th
                title='Final IVA Status'
                className=' tw-px-1 tw-w-[18%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-whitespace-nowrap tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Assigned By
              </th>
              <th
                title='Resolution'
                className='tw-px-1 tw-w-[18%] tw-bg-blue-200 tw-text-grey-800 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300/90 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'
              >
                Unassigned At
              </th>
              <th
                title='Resolution Amt'
                className='tw-px-1 tw-whitespace-nowrap tw-w-[18%] tw-bg-blue-200 tw-text-grey-800 tw-text-center tw-overflow-hidden tw-text-ellipsis'
              >
                Unassigned By
              </th>
            </tr>
          </thead>
          <tbody className='tw-bg-white'>
            {data?.assignment_history?.map(
              (
                {
                  name,
                  driver_fe_id,
                  phone_no,
                  assigned_at,
                  assigned_by,
                  unassigned_at,
                  unassigned_by,
                  tag,
                  calling_enabled = true,
                  calling_disabled_reason = '',
                },
                index,
              ) => {
                return (
                  <tr
                    key={name || index}
                    className={
                      index === data?.assignment_history.length - 1
                        ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                        : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                    }
                  >
                    <td
                      className={`
    tw-px-2 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-cursor-pointer tw-relative tw-group
    ${index === data?.assignment_history.length - 1 ? 'tw-rounded-bl-xl' : ''}
  `}
                    >
                      <div className='tw-flex tw-flex-col tw-items-center tw-gap-2'>
                        <span
                          className='tw-font-medium tw-text-[1.5rem] tw-leading-none'
                          data-dd-privacy='mask'
                        >
                          {name}
                          {tag && (
                            <span className='tw-rounded-lg tw-text-[1.2rem] tw-px-2 tw-py-1 tw-font-medium tw-leading-none tw-bg-teal-100 tw-text-teal-600 tw-whitespace-nowrap tw-m-2'>
                              {tag}
                            </span>
                          )}
                        </span>
                        {driver_fe_id ? (
                          <CopyText
                            title={driver_fe_id}
                            customClass='tw-text-grey-800 tw-text-[1.4rem] tw-font-medium'
                            position='right'
                          />
                        ) : null}
                      </div>
                    </td>
                    <td
                      className='tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-w-[10px]'
                      data-dd-privacy='mask'
                    >
                      {phone_no && (
                        <div className='tw-flex tw-justify-center tw-gap-2 tw-items-center'>
                          <ValetDeliveryAssignmentHistory
                            offset={index}
                            phone={phone_no}
                            orderId={orderId}
                            userId={userId}
                            calledTo={'Rider'}
                          />
                          <WFHCall
                            isCallingDisabled={
                              calling_enabled === undefined ||
                              calling_enabled === null
                                ? false
                                : !calling_enabled
                            }
                            callingDisabledReason={calling_disabled_reason}
                            orderId={orderId}
                            userId={userId}
                            title={phone_no}
                            calledTo={
                              ambulanceRoles.includes(tag) ? tag : 'Rider'
                            }
                            role={
                              tag === 'Buddy Rider'
                                ? riderRoles.BUDDY_RIDER
                                : ambulanceRoles.includes(tag)
                                ? tag.toUpperCase()
                                : riderRoles.RIDER
                            }
                            valetId={driver_fe_id}
                            sendJumboEvent={true}
                            jumboEventFunc={AssignedRiderCallClickEvent}
                            JumboEventProperties={{
                              is_new_ui: isNewUI,
                              valet_name: name,
                              valet_number: phone_no,
                              valet_id: driver_fe_id,
                              assigned_by: assigned_by,
                            }}
                            cartId={cartId}
                          />
                        </div>
                      )}
                    </td>
                    <td className='tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-snug'>
                      {assigned_at}
                    </td>
                    <td
                      className='tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-snug'
                      data-dd-privacy='mask'
                    >
                      {assigned_by}
                    </td>
                    <td className='tw-px-1 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-leading-snug'>
                      {unassigned_at}
                    </td>
                    <td
                      className={
                        index === data?.assignment_history - 1
                          ? 'tw-rounded-br-2xl tw-border-none tw-px-1'
                          : 'tw-px-1'
                      }
                      data-dd-privacy='mask'
                    >
                      {unassigned_by}
                    </td>
                  </tr>
                );
              },
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
